import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./rootReducer";
import { digitalSalesApiSlice } from "../common/api/digital-sales";
import { syncDataModalReducer } from "../modals/SyncDataModal/SyncDataModalSlice";
import { localDataReducer } from "../common/slices/localDataSlice";
import { productGalleryModalReducer } from "../modals/productGalleryModal/productGalleryModalSlice";
import { productRangeReducer } from "../pages/productRangePage/ProductRangeSlice";
import { productDetailsReducer } from "../pages/productDetail/ProductDetailsSlice";
import { searchReducer } from "../pages/searchPage/SearchPageSlice";
import { brandingReducer } from "../pages/brandingPage/BrandingSlice";

export const store = configureStore({
    reducer: {
        root: rootReducer,
        syncDataModal: syncDataModalReducer,
        localData: localDataReducer,
        productGalleryModal: productGalleryModalReducer,
        productRange: productRangeReducer,
        branding: brandingReducer,
        productDetails: productDetailsReducer,
        search: searchReducer,
        [digitalSalesApiSlice.reducerPath]: digitalSalesApiSlice.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({}).concat(digitalSalesApiSlice.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
